export default {
    "preview": {
        "noDocumentDataErrorPopupTitle": "Echec d'accès aux données de ce document",
        "highlightsTitle": "Surlignage",
        "noEntityToHighlight": "Aucune entité affichée dans ce document",
        "termXLabel": "Terme recherché {index, number}",
        "otherTerms": "Autres termes",
        "previousDocument": "Précédent",
        "nextDocument": "Suivant",
        "originalDocument": "Document original",
        "selectedHighlight": "Elément sélectionné",
        "noSelectedHighlight": "Aucun élément sélectionné",
        "firstHighlightButtonAltText": "Premier élément",
        "previousHighlightButtonAltText": "Elément précédent",
        "nextHighlightButtonAltText": "Elément suivant",
        "relevanceSortHighlightButtonText": "Pertinence",
        "textOrderSortHighlightButtonText": "Ordre du texte",
        "lastHighlightButtonAltText": "Dernier élément",
        "highlightFilters": {
            "title": "Filtres",
            "keepAll": "Tout inclure",
            "keepNone": "Tout exclure",
            "keepAllInCategory": "Toutes les entités",
            "keepNoneInCategory": "Aucune entité"
        },
        "documentPropertiesTitle": "Détails",
        "similarDocumentsTitle": "Documents similaires",
        "showAll": "Montrer toutes les valeurs",
        "sortAlphabetically": "Trier par ordre alphabetique",
        "sortFrequency": "Trier par fréquence",
        "loading": "Chargement...",
        "noextract": "Pas d'extrait",
        "search": "Recherche",
        "gotopage": "Aller à la page",
        "page": "Page {page}",
        "current": "actuel"
    },
    "facet": {
        "preview": {
            "closeTitle": "Fermer",
            "expandTitle": "Maximiser",
            "minimize": "Réduire",
            "maximize": "Agrandir",
            "toggleExtracts": "Surlignage des extraits pertinents",
            "extracts": "Extraits Pertinents",
            "toggleEntities": "Surlignage des entités",
            "entities": "Entités",
            "passages": "Passages Pertinents",
            "showPassages": "Montrer/cacher les passages extraits par Neural Search",
            "downloadPdf": "Télécharger la version PDF",
            "viewPreview": "Aperçu",
            "viewPassages": "Passages",
            "documentPreview": "Aperçu de document",
            "documentPreviewTitle": "Ceci est l'aperçu de document",
            "documentPreviewDescription": "Cliquez sur l'un des résultats de votre recherche pour avoir un aperçu du document ici."
        }
    }
};
